<template>
    <span>
        <select v-if="type === 'select'"
                ref="input"
                :id="id"
                v-model="tempValue"
                @change="handleInput($event.target.value)"
                @blur="handleBlur"
                class="input">
            <option v-for="option in options" :value="option[option_value]" v-text="option[option_name]"></option>
        </select>

        <select v-if="type === 'states'"
                ref="input"
                :id="id"
                v-model="tempValue"
                @change="handleInput($event.target.value)"
                @blur="handleBlur"
                class="input">
            <option v-text="placeholder"></option>
            <option v-for="(state, index) in states" :value="index" v-text="state"></option>
        </select>

        <timezone-picker v-if="type === 'timezone'"
                         ref="input"
                         :id="id"
                         :value="tempValue"
                         @input="handleInput($event)"
                         @blur="handleBlur">
        </timezone-picker>

        <textarea v-if="type === 'textarea'"
                  ref="input"
                  :id="id"
                  :placeholder="placeholder"
                  v-model="tempValue"
                  @input="handleInput($event.target.value)"
                  @keydown="handleKeyDown($event)"
                  @blur="handleBlur"
                  class="textarea"></textarea>

        <label class="checkbox" :for="id" v-if="type === 'checkbox'">
            <input ref="input"
                   :id="id"
                   :type="type"
                   :value="tempValue"
                   :checked="value === true"
                   @change="handleCheckbox"
                   @blur="handleBlur"
                   class="checkbox">
            <slot name="label"></slot>
        </label>

        <input v-if="type === 'file'"
               ref="input"
               :id="id"
               :type="type"
               :value="tempValue"
               :checked="value === true"
               @change="handleCheckbox"
               @blur="handleBlur"
               class="input">

        <input v-if="type !== 'select' &&
                     type !== 'timezone' &&
                     type !== 'states' &&
                     type !== 'textarea' &&
                     type !== 'radio' &&
                     type !== 'file' &&
                     type !== 'checkbox'"
               ref="input"
               :id="id"
               :type="type"
               :value="tempValue"
               :placeholder="placeholder"
               @input="handleInput($event.target.value)"
               @keydown="handleKeyDown($event)"
               @blur="handleBlur"
               class="input">
        <slot></slot>
    </span>
</template>

<script>
import {mapState} from "vuex"
import Masker     from "../../helpers/masker";
import states     from "../../helpers/us-states"

export default {
  props: {
    id: { type: String, default: null },
    placeholder: { type: [String], default: '' },
    type: { type: String, default: 'text' },
    value: { type: [Number, Boolean, String], default: '' },
    trueValue: { type: [Number, Boolean, String], default: true },
    falseValue: { type: [Number, Boolean, String], default: false },
    mask: { type: [Boolean, String], default: false },
    saveMask: { type: [Boolean, String], default: false },
    options: { type: [String, Object, Array], default: () => [] },
    option_name: { type: [String], default: 'id' },
    option_value: { type: [String], default: 'id' },
    required: { type: [Boolean], default: false },
  },
  data() {
    return {
      states,
      tempValue: '',
      activeKeyCode: 0,
    }
  },
  mounted() {
    this.tempValue = (this.type === 'checkbox' || this.type === 'radio')
      ? this.value
      : (this.value) ? (this.value !== 'true' && this.value.toString() === 'true' ? '' : this.value.toString()) : '';
    this.handleInput(this.tempValue, false)
  },
  methods: {
    getCaretPosition() {
      if (this.mask === false) return;
      Masker.readCaretPosition(this.$refs.input)
    },

    handleKeyDown(e) {
      this.activeKeyCode = e.keyCode || e.charCode;
      if (this.mask === false) {
        if (this.activeKeyCode === 8 && this.activeKeyCode === 46) {
          this.handleInput(this.$refs.input.value)
        }
        return;
      }
      this.getCaretPosition()
    },

    handleInput(value, updateCaret) {
      // no mask was specified, save the new value to tempValue and emit another input event up the chain
      this.tempValue = (value === null) ? '' : value;
      if (this.mask === false) {
        this.emitOtherEvent('input', value)
        return;
      }

      // a mask was specified, if not deleting, apply the mask and update the input's value
      if (this.activeKeyCode !== 8 && this.activeKeyCode !== 46) {
        value                  = Masker.applyMask(Masker.removeMask(value, this.mask), this.mask);
        this.$refs.input.value = value;
        this.tempValue         = value;
        if (updateCaret !== false) Masker.updateCaretPosition(this.$refs.input, this.activeKeyCode)
      }

      // apply the save mask
      value = this.applySaveMask(value);
      // emit the formatted value up the chain
      this.emitOtherEvent('input', value)
    },

    applyMask(value) {
      this.$refs.input.value = value = Masker.applyMask(Masker.removeMask(value, this.mask), this.mask)
      this.tempValue         = value;
    },

    applySaveMask(value) {
      if (this.saveMask === true) {
        value = Masker.applyMask(Masker.removeMask(value, this.mask), this.mask)
      }
      else if (this.saveMask === false) {
        value = Masker.removeMask(value, this.mask)
      }
      else {
        value = Masker.applyMask(Masker.removeMask(value, this.mask), this.saveMask)
      }
      return value;
    },

    handleCheckbox(event) {
      this.emitOtherEvent('input', event.target.checked ? this.trueValue : this.falseValue)
    },

    handleBlur(event) {
      let newEvent = {
        target: {
          id: event.target.id,
          value: event.target.value
        }
      }

      if (this.mask) {
        newEvent.target.value = this.applySaveMask(newEvent.target.value)
      }

      this.emitOtherEvent('blur', newEvent)
    },

    emitOtherEvent(type, payload) {
      if (type === 'input') this.$emit('input', payload)

      this.$emit('event', { type, payload, target: this.id })
    }
  }
};
</script>



// WEBPACK FOOTER //
// FormControl.vue?4361edc8